// Network layer for auth and sync; no Vuex, no history writes, no DOM.

var AUTH_KEY = 'ezshadowAuth.v1';
var API_BASE = process.env.TRANSCRIPT_API_URL || 'http://localhost:8788';

export function getStoredAuth() {
  try {
    var raw = localStorage.getItem(AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) { return null; }
}

export function setStoredAuth(data) {
  try {
    if (data) localStorage.setItem(AUTH_KEY, JSON.stringify(data));
    else localStorage.removeItem(AUTH_KEY);
  } catch (_) {}
}

function authHeaders(token) {
  return { Authorization: 'Bearer ' + token };
}

export function signInWithGoogle(credential) {
  return fetch(API_BASE + '/v1/auth/google', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ credential: credential })
  }).then(function(res) {
    if (!res.ok) return res.json().then(function(body) {
      var err = new Error(body.error || ('AUTH_FAILED_' + res.status));
      err.status = res.status;
      throw err;
    });
    return res.json();
  });
}

export function fetchMe(token) {
  return fetch(API_BASE + '/v1/auth/me', {
    headers: authHeaders(token)
  }).then(function(res) {
    if (res.status === 401) return null;
    if (!res.ok) throw new Error('ME_FAILED_' + res.status);
    return res.json();
  });
}

export function logoutRequest(token) {
  return fetch(API_BASE + '/v1/auth/logout', {
    method: 'POST',
    headers: authHeaders(token)
  }).catch(function() {});
}

export function deleteAccountRequest(token) {
  return fetch(API_BASE + '/v1/account', {
    method: 'DELETE',
    headers: authHeaders(token)
  }).catch(function() {});
}

/** @returns {{pushed, at}|{unauthorized: true}} */
export function pushSync(token, sessions, dayDeltas) {
  return fetch(API_BASE + '/v1/sync/push', {
    method: 'POST',
    headers: Object.assign({ 'Content-Type': 'application/json' }, authHeaders(token)),
    body: JSON.stringify({ sessions: sessions, dayDeltas: dayDeltas })
  }).then(function(res) {
    if (res.status === 401) return { unauthorized: true };
    if (!res.ok) throw new Error('PUSH_FAILED_' + res.status);
    return res.json();
  });
}

/** @param {string} since ISO date. @returns {{sessions, dayTotals, pulledAt}|{unauthorized: true}} */
export function pullSync(token, since) {
  var url = API_BASE + '/v1/sync/pull?since=' + encodeURIComponent(since || '1970-01-01T00:00:00.000Z');
  return fetch(url, { headers: authHeaders(token) }).then(function(res) {
    if (res.status === 401) return { unauthorized: true };
    if (!res.ok) throw new Error('PULL_FAILED_' + res.status);
    return res.json();
  });
}
